import { defineMessage } from 'services/localization';

export const messages = {
    openApprovalMatrixButtonTitle: defineMessage('define_approval_conditi__in_the_approval_matrix'),
    addApprover: defineMessage('add_an_approver'),
    defaultApprover: defineMessage('default_approver_1'),
    defaultApproverDescription: defineMessage('a_default_approver_is_a_prover_specified_for_it'),
    errorMessage: defineMessage('add_at_least_one_approver_or_remove_this_step'),
    emptyStepDescription: defineMessage('add_at_least_one_approv__in_the_approval_matrix'),
};
